import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {

  constructor(private router:Router, public alertController:AlertController) { }

  ngOnInit() {
  }
  async recieveNotifications(){
    const alert= await this.alertController.create({
      header:'Notifications',
      message:"You will be notified about your orders and new offers.",
      buttons:['OK'],
      
    })
    await alert.present();
    // code
    this.router.navigate(['../tabs/tabs/home']);

  }
   async offNotifications(){
    // dont send notifications
    const alert= await this.alertController.create({
      header:'Notifications',
      message:"You will not recieve any updates or offers",
      buttons:['OK'],
      
    })
    await alert.present();
    // code
    this.router.navigate(['../tabs/tabs/home']);


  }
}
